import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import Navbar from "../components/Landing/shared/Navbar";
import DiscountOffer from "../components/Landing/shared/DiscountOffer";
import Footer from "../components/Landing/shared/Footer";
import { Hidden } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    wrapper: {
        width: "100%",
    },
    contentBox: {
        minHeight: "100vh",
        position: "relative",
    },
}));

const LandingLayout = ({ children }) => {
    const classes = useStyles();

    return (
        <Box className={classes.wrapper}>
            <Navbar />
            <Hidden xsDown>
                <DiscountOffer />
            </Hidden>

            <Box className={classes.contentBox}>{children}</Box>

            <Footer />
        </Box>
    );
};

export default LandingLayout;
